module.exports = __webpack_public_path__ + "img/组1075.91b3a79d.png";